import { get, post, Delete } from '@/utils/https';

export const fetchReports = (params) => get('/api/app/v1/activity-report', params);

export const togglePaidStatus = (activityReportId, paidType) => post(`/api/app/v1/activity-report/${activityReportId}/toggle-paid-status`, { paid_type: paidType });

export const deleteReport = (activityReportId) => Delete(`/api/app/v1/activity-report/${activityReportId}`);

export const exportSepaXml = (ids, config) => post('/api/app/v1/activity-report/export-sepa-xml', { ids }, config);
export const fetchReportExport = (activityReportId) => get(`/api/app/v1/activity-report/${activityReportId}/export`);

export const fetchMissionOptions = (params) => get('/api/app/v1/activity-report/missions/options', params);
export const fetchMissionList = (params) => get('/api/app/v1/activity-report/missions', params);
export const fetchAvailablePeriods = (params) => get('/api/app/v1/activity-report/available-periods', params);
export const fetchReminderDates = () => get('/api/app/v1/activity-report/reminder-dates');

export const fetchReportDetail = (activityReportId) => get(`/api/app/v1/activity-report/${activityReportId}/detail`);

export const createReport = (data) => post('/api/app/v1/activity-report', data);
export const saveDraft = (activityReportId, data) => post(`/api/app/v1/activity-report/${activityReportId}/draft`, data);
export const submitReport = (activityReportId, data) =>
  post(`/api/app/v1/activity-report/${activityReportId}/submit`, data, { hideMessageModal: true });
export const reviewReport = (activityReportId, data) => post(`/api/app/v1/activity-report/${activityReportId}/review`, data);
export const reopenRejectedReport = (activityReportId) => post(`/api/app/v1/activity-report/${activityReportId}/approve-rejected`);
/** Resend client validation email (ESN mode – référent externe) */
export const resendClientValidationEmail = (activityReportId) =>
  post(`/api/app/v1/activity-report/${activityReportId}/resend-client-validation-email`, {});

/** Run invoice verification (Mindee extraction + compare to expected amount). Body: { file_key, expected_amount_excl_vat? } */
export const runInvoiceVerification = (activityReportId, body) =>
  post(`/api/app/v1/activity-report/${activityReportId}/invoice-verification/run`, body, {
    timeout: 130000, // 2 min 10 s (backend polls Mindee up to 2 min)
  });

/** Attach an invoice PDF from accounting (e.g. portage umbrella invoice). */
export const attachAccountingInvoice = (activityReportId, body) =>
  post(`/api/app/v1/activity-report/${activityReportId}/accounting-invoice`, body, {
    hideMessageModal: true,
  });

/** Remove the attached invoice PDF from accounting. */
export const deleteAccountingInvoice = (activityReportId) =>
  Delete(`/api/app/v1/activity-report/${activityReportId}/accounting-invoice`, undefined, {
    hideMessageModal: true,
  });

export const initializeActivityReport = (missionIds, reportMonthOrPeriodLabel, periodLabelOnly) => {
  const normalizedMissionIds = Array.isArray(missionIds) ? missionIds : [missionIds];
  const payload = {
    mission_ids: normalizedMissionIds,
    // Compatibility while the backend rollout still accepts the legacy field.
    mission_id: normalizedMissionIds[0],
  };
  if (reportMonthOrPeriodLabel && /^\d{4}-\d{2}$/.test(String(reportMonthOrPeriodLabel).trim())) {
    payload.report_month = String(reportMonthOrPeriodLabel).trim();
  }
  if (periodLabelOnly) {
    payload.period_label = periodLabelOnly;
  } else if (reportMonthOrPeriodLabel && !/^\d{4}-\d{2}$/.test(String(reportMonthOrPeriodLabel).trim())) {
    payload.period_label = reportMonthOrPeriodLabel;
  }
  return post('/api/app/v1/activity-report/initialize', payload);
};

export default {
  fetchReports,
  togglePaidStatus,
  deleteReport,
  exportSepaXml,
  fetchReportExport,
  fetchMissionOptions,
  fetchMissionList,
  fetchAvailablePeriods,
  fetchReminderDates,
  fetchReportDetail,
  createReport,
  saveDraft,
  submitReport,
  reviewReport,
  reopenRejectedReport,
  resendClientValidationEmail,
  runInvoiceVerification,
  attachAccountingInvoice,
  deleteAccountingInvoice,
  initializeActivityReport,
};
